// extracted by mini-css-extract-plugin
export default {"disabled":"BKgEntrance-module_disabled_b32555df"};